import { CallStats, StatsCommon } from '#common/stats';
export class EpochManagerStats extends StatsCommon {
    connectEpoch;
    reportEpoch;
    constructor(log) {
        super();
        this.connectEpoch = new CallStats('connectEpoch', log);
        this.reportEpoch = new CallStats('reportEpoch', log);
    }
}
export class NodeStats extends StatsCommon {
    fetchNodeIndex;
    constructor(log) {
        super();
        this.fetchNodeIndex = new CallStats('fetchNodeIndex', log);
    }
}
